import React, { useState, useEffect } from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  FileInput,
  ImageField,
  useUpdate,
  useNotify,
  useRedirect,
  Toolbar,
  SaveButton,
  required
} from 'react-admin';
import { uploadImage } from '../../../config/services/strapi/strapi';

function PLGImagenesInicioEdit(props: any) {
  const [portadaChanged, setPortadaChanged] = useState(false);

  const [update] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();

  // Asegúrate de usar el mismo nombre que en el List/Create
  const resourceName = 'plg-imagenes-inicioss';

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      if (!token) {
        notify('No se encontró el token de autenticación', { type: 'error' });
        return;
      }

      // Preparamos el payload base
      const payload: Record<string, any> = {
        titulo: data.titulo,
      };

      // Solo subimos la imagen si el usuario la cambió
      if (portadaChanged && data.portada && data.portada.rawFile) {
        const portadaUploaded = await uploadImage(data.portada.rawFile, token);
        payload.portada = { id: portadaUploaded.id };
      }

      update(resourceName, { id: data.id, data: payload }, {
        onSuccess: () => {
          notify('Registro actualizado con éxito', { type: 'success' });
          redirect('list', resourceName);
        },
        onError: (error: any) => {
          notify(`Error: ${error.message}`, { type: 'error' });
        },
      });

    } catch (error) {
      console.error('Error during update:', error);
      notify('Error al actualizar el registro', { type: 'error' });
    }
  };

  useEffect(() => {
    document.title = 'Editar PLG Inicio';
  }, []);

  return (
    <Edit {...props}>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput
          source="titulo"
          label="Título"
          validate={[required()]}
          fullWidth
        />

        <FileInput
          source="portada"
          label="Cambiar Portada"
          multiple={false}
          onChange={() => setPortadaChanged(true)}
        >
          <>
            {/* Si cambió, muestra el preview local (src), si no, muestra la de la API (url) */}
            {portadaChanged && <ImageField source="src" title="title" />}
            {!portadaChanged && <ImageField source="url" title="title" />}
          </>
        </FileInput>

      </SimpleForm>
    </Edit>
  );
}

export default PLGImagenesInicioEdit;